import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton } from '@/components';

interface FormActionsProps {
  submitLabel: string;
  isSaving: boolean;
  onCancel: () => void;
  onSubmit: () => void;
}

const FormActions = ({ submitLabel, isSaving, onCancel, onSubmit }: FormActionsProps) => (
  <div className='sticky bottom-0 z-[1200] flex flex-wrap gap-2.5 justify-end border-t border-gray-200 bg-gray-50 px-6 py-4'>
    <GlobalButton
      variant={GlobalButtonVariant.secondaryButton}
      action={onCancel}
      disabled={isSaving}
    >
      Cancelar
    </GlobalButton>
    <GlobalButton
      variant={GlobalButtonVariant.primaryButton}
      action={onSubmit}
      disabled={isSaving}
    >
      {isSaving ? 'Guardando...' : submitLabel}
    </GlobalButton>
  </div>
);

export default FormActions;
